export const certificateTypeOptions = [
  { label: 'Drivers license', value: 'driversLicense' },
  { label: 'Safety certificate', value: 'safetyCertificate' },
  { label: 'Other', value: 'other' },
];
